import { removeDuplicate } from "./array";

// when input onChange, set new value, then check for errors
// pattern is a regex
const onChange = (
  event,
  setFunction,
  required = false,
  pattern = null,
  itemName,
  errors = [],
  setErrors = () => {},
) => {
  const str = event.target.value;
  setFunction(str);

  let newErrors = errors;

  const requiredError = `${itemName}是必要的`;

  if (required && str.trim() === "") {
    newErrors.push({ msg: requiredError });
  } else {
    // remove
    newErrors = newErrors.filter((item) => item.msg !== requiredError);
  }

  const patternError = `${itemName}不符合格式`;

  // if pattern isn't null, test the pattern
  if (pattern !== null && str !== "" && !pattern.test(str)) {
    newErrors.push({ msg: patternError });
  } else {
    // remove
    newErrors = newErrors.filter((item) => item.msg !== patternError);
  }

  newErrors = removeDuplicate(newErrors, "msg");
  setErrors(newErrors);
};

export { onChange };
